import { TIconSize } from './types'

export const ICONS_SIZES_DATA = {
  small: 16,
  medium: 24,
  large: 32,
  huge: 40,
  extraSmall: 12,
  xLarge: 48
}

export const getSizeWithPixels = (size: TIconSize): number =>
  ICONS_SIZES_DATA[size]
